import {view} from '@sail/ui';

import {ScreenContentLayout} from 'src/fund/components/screen/ScreenContentLayout';
import {useSelector} from 'src/fund/state/store';

export const TokenSelectScreen = () => {
  const cryptoWalletFundingOptions = useSelector(
    (state) => state.cryptoWalletFundingOptions,
  );

  return (
    <ScreenContentLayout>
      <view.div data-testid="funding-session-ready">
        Funding session ready
        <view.div>Select token</view.div>
        <view.pre
          css={{whiteSpace: 'pre-wrap', overflowWrap: 'anywhere'}}
          data-testid="funding-session-options"
        >
          {JSON.stringify(cryptoWalletFundingOptions, null, 2)}
        </view.pre>
      </view.div>
    </ScreenContentLayout>
  );
};
